@if (showSpinner) {
  <app-loader> </app-loader>
}
<main class="content-wrapper" [ngClass]="{ 'dark-backround-main': selectedMode === 'dark' }">
  <div class="container-fluid mb-4" [ngClass]="{ 'dark-backround-main': selectedMode === 'dark' }">
    <form id="form-link-outside-btn" name="policy" #f="ngForm" (ngSubmit)="onSubmit(f)">
      <div class="create-form pt-2 pl-4 pr-4 border" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
        <div class="mb-4">
          @if ( !this.uuid) {
            <h5>+ Add New Policy</h5>
          }
          @if (this.uuid) {
            <h5>update Policy</h5>
          }
        </div>

        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <input type="text" name="policy_title"  [(ngModel)]="policy_title" placeholder="Enter Policy Title Here....." ngModel required>
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group">
              <ckeditor [editor]="Editor" name="policy_description"  [(ngModel)]="policy_description" required></ckeditor>
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group">
              <button class="btn btn-danger mr-3" routerLink="/policy" >
                Cancel
              </button>
              @if (!this.uuid) {
                <button class="btn btn-primary" type="submit" [disabled]="f.invalid">
                  Add Policy
                </button>
              }
              @if (this.uuid) {
                <button class="btn btn-primary" type="submit" [disabled]="f.invalid">
                  Update Policy
                </button>
              }
            </div>
          </div>
        </div>
      </div>
    </form>



  </div>
</main>